import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'confirm-participation-dialog',
    templateUrl: './confirmParticipationDialog.component.html',
    styleUrls: ['./confirmParticipationDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ConfirmParticipationDialogComponent {
    data: any;

    constructor(
        public matDialogRef: MatDialogRef<ConfirmParticipationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) {
        this.data = _data.data;
    }

}
